module.exports = __webpack_public_path__ + "static/media/yellow.dc9d57f9.svg";